import { useEffect, useState } from "react";
import { getProfile } from "../../../core/api/auth";

export const useUserProfile = () => {
  const [profile, setProfile] = useState({
    role: null,
    page_authorization: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getProfile();
        setProfile({
          role: data?.role || null,
          page_authorization: data?.page_authorization || [],
          loading: false,
          error: null,
        });
      } catch (error) {
        setProfile({ role: null, page_authorization: [], loading: false, error });
        console.error("Failed to fetch profile:", error);
      }
    };

    fetchProfile();
  }, []);

  const hasPermission = (pathPrefix) => {
    const cleanedPrefix = pathPrefix.replace(/\*$/, "");

    if (profile.role === "super_admin") {
      return true;
    }

    return profile.page_authorization.some((perm) =>
      perm.replace(/\*$/, "").startsWith(cleanedPrefix)
    );
  };

  return {
    role: profile.role,
    permissions: profile.page_authorization,
    loading: profile.loading,
    error: profile.error,
    hasPermission,
  };
};
